var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('button',{staticClass:"small-btn",class:[
    _vm.type,
    {
      'full': _vm.isFull
    }
  ],on:{"click":_vm.handleClick}},[_c('span',[_vm._t("default",[_vm._v("Button")])],2)])])}
var staticRenderFns = []

export { render, staticRenderFns }